/**
 * CSV utilities for admin exports and imports.
 *
 * CSV escaping follows RFC 4180: wrap every field in quotes and double any
 * embedded quotes. Cheap and sufficient for the admin's export shapes.
 */

/** Escape a single CSV field per RFC 4180. */
export function csvField(value: string): string {
  const escaped = value.replace(/"/g, '""');
  return `"${escaped}"`;
}

/**
 * Build a CSV string from a 2D array of rows. The first row is typically
 * the header. Values are RFC 4180 escaped; rows are joined with `\n`.
 */
export function buildCsv(rows: string[][]): string {
  return rows.map((row) => row.map(csvField).join(",")).join("\n");
}

/**
 * Trigger a browser download of a CSV file from a 2D array of rows.
 * Uses a Blob URL + synthetic anchor click. Revokes the URL after the
 * click to avoid leaking object-URL references.
 */
export function downloadCsv(filename: string, rows: string[][]): void {
  const body = buildCsv(rows);
  const blob = new Blob([body], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
